// WBESC
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
